module.exports = __webpack_public_path__ + "img/anna.ea66dbd.webp";